/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BatchExtractCharacterUrlsFromUrlRequest } from '../../models/batch-extract-character-urls-from-url-request';
import { BatchExtractCharacterUrlsFromUrlResponse } from '../../models/batch-extract-character-urls-from-url-response';

export interface AdminServiceBatchExtractCharacterUrlsFromUrl$Params {
      body: BatchExtractCharacterUrlsFromUrlRequest
}

export function adminServiceBatchExtractCharacterUrlsFromUrl(http: HttpClient, rootUrl: string, params: AdminServiceBatchExtractCharacterUrlsFromUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<BatchExtractCharacterUrlsFromUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceBatchExtractCharacterUrlsFromUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BatchExtractCharacterUrlsFromUrlResponse>;
    })
  );
}

adminServiceBatchExtractCharacterUrlsFromUrl.PATH = '/api/v3/gateway/admin/extract/character/batch';
